"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _progressBarModule = _interopRequireDefault(require("./sass/progressBar.module.scss"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress,
      control = _ref.control,
      type = _ref.type,
      nameDisplay = _ref.nameDisplay,
      isPercentage = _ref.isPercentage,
      className = _ref.className;
  // const race = [
  //   { name: 'Asian', value: 9 },
  //   { name: 'Hispanic', value: 45 },
  //   { name: 'White', value: 67 },
  // ]
  var grades = [{
    name: '6',
    value: 86
  }, {
    name: '7',
    value: 17
  }, {
    name: '8',
    value: 47
  }];
  var maxAmount = 150; // value * 100 / maxAmount

  var newValues = grades.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      value: Math.ceil(item.value * 100 / maxAmount)
    });
  });
  var colorBar = type === 'control' ? '#52BD94' : type === 'progress' ? '#008CFF' : type === 'star' ? '#efd24c' : null;
  return /*#__PURE__*/_react.default.createElement("div", null, nameDisplay ? /*#__PURE__*/_react.default.createElement("label", {
    className: _progressBarModule.default.nameLabel
  }, nameDisplay) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_progressBarModule.default.barContainerNum, " ").concat(className && className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _progressBarModule.default.barContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "bar-element",
    className: _progressBarModule.default.barContainer_progress,
    style: {
      width: "".concat(progress, "%"),
      background: colorBar
    }
  }), type === 'control' && /*#__PURE__*/_react.default.createElement("div", {
    className: _progressBarModule.default.barContainer_control,
    style: {
      left: "calc(".concat(control, "% - 16px)")
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _progressBarModule.default.barContainer_control_num
  }, control, "%"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "\n            ".concat(_progressBarModule.default.barContainerNum_number, "\n            ").concat(type === 'progress' ? _progressBarModule.default.barContainerNum_progressNum : _progressBarModule.default.barContainerNum_controlNum, "\n          "),
    id: "percentage"
  }, /*#__PURE__*/_react.default.createElement("div", null, progress), /*#__PURE__*/_react.default.createElement("div", null, isPercentage && '%'))));
};

ProgressBar.defaultProps = {
  type: 'progress',
  progress: 0,
  control: 0,
  nameDisplay: null,
  isPercentage: false,
  className: null,
  colorBar: 'red'
};
ProgressBar.propTypes = {
  type: _propTypes.default.oneOf(['progress', 'control', 'star']),
  progress: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  control: _propTypes.default.number,
  nameDisplay: _propTypes.default.string,
  isPercentage: _propTypes.default.bool,
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
};
var _default = ProgressBar;
exports.default = _default;